import template from "./stockList.html";
import controller from "./stockList.controller";

export default {
	restrict: "E",
	bindings: {
		list: "=",
		toTransfer: "=",
		hidePricing: "=",
	},
	template,
	controller,
	controllerAs: "vm",
};



// WEBPACK FOOTER //
// ./src/app/common/ui/stockList/stockList.component.js